/**
 * SOLDES — mise à jour de l'affichage au changement de variante.
 *
 * Contexte : en mode soldes (metafield produit `soldes.sale_price`), `price-list.liquid`
 * et `product-badges.liquid` rendent le prix barré / soldé / badge SANS attribut `form`,
 * car le handler natif (theme.js) recalcule à tort depuis `compare_at_price` (vide dans le
 * nouveau modèle) et masquerait le barré/badge. Ce script prend le relais.
 *
 * L'événement `variant:change` est émis sur le <form> (bubbles: true → remonte à document).
 *   event.target      = le <form>  → event.target.id = le form_id
 *   event.detail.variant.id        = la variante sélectionnée
 *
 * Données fournies par Liquid :
 *   <script type="application/json" data-soldes-map data-sale="49,00 €" data-form="...">
 *     { "<variantId>": { "onSale": true, "full": "70,00 €", "savings": "30%" }, ... }
 *   </script>
 *   <sale-price data-soldes-sale>...<span data-soldes-amount>…</span></sale-price>
 *   <compare-at-price data-soldes-compare>...<span data-soldes-amount>…</span></compare-at-price>
 *   <on-sale-badge data-soldes-badge data-form="...">…</on-sale-badge>
 */
(function () {
  "use strict";

  function parseMap(script) {
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function setAmount(el, html) {
    if (!el) return;
    var amount = el.querySelector("[data-soldes-amount]");
    if (amount) amount.innerHTML = html;
  }

  function handleVariantChange(event) {
    var detail = event.detail || {};
    var variant = detail.variant;
    if (!variant) return;

    var form = event.target;
    var formId = form && form.id ? form.id : null;
    var key = String(variant.id);

    var scripts = document.querySelectorAll("script[data-soldes-map]");

    // 1) Prix barré + prix soldé, pour chaque price-list piloté par ce formulaire.
    for (var i = 0; i < scripts.length; i++) {
      var script = scripts[i];
      if (formId && script.dataset.form && script.dataset.form !== formId) continue;

      var map = parseMap(script);
      if (!map) continue;
      var data = map[key];
      if (!data) continue;

      var container = script.closest("price-list") || script.parentElement;
      if (!container) continue;

      var saleEl = container.querySelector("[data-soldes-sale]");
      var compareEl = container.querySelector("[data-soldes-compare]");
      var saleMoney = script.dataset.sale || "";

      setAmount(saleEl, data.onSale ? saleMoney : data.full);

      if (compareEl) {
        setAmount(compareEl, data.full);
        compareEl.hidden = !data.onSale;
      }
    }

    // 2) Badge de remise (rendu dans un bloc séparé, relié par form_id).
    if (!formId) return;

    var badgeData = null;
    for (var j = 0; j < scripts.length; j++) {
      if (scripts[j].dataset.form === formId) {
        var m = parseMap(scripts[j]);
        if (m) badgeData = m[key];
        break;
      }
    }

    var template =
      window.themeVariables &&
      window.themeVariables.strings &&
      window.themeVariables.strings.discountBadge;

    var badges = document.querySelectorAll(
      'on-sale-badge[data-soldes-badge][data-form="' + formId + '"]'
    );

    for (var k = 0; k < badges.length; k++) {
      var badge = badges[k];
      if (!badgeData) {
        badge.hidden = true;
        continue;
      }
      badge.hidden = !badgeData.onSale;
      if (badgeData.onSale && template) {
        badge.innerHTML = template.replace("@@", badgeData.savings);
      }
    }
  }

  document.addEventListener("variant:change", handleVariantChange);
})();
